export const menuDynamic = [
  {
    id: 1,
    text: 'Pódio Consultores',
    clickable: true,
    componentName: 'ConsultantPodium',
  },
  {
    id: 2,
    text: 'Pódio Supervisores',
    clickable: true,
    componentName: 'SupervisorsPodium',
  },
  { id: 3, text: 'Modo Apresentação', icon: 'Maximize', clickable: true },
  {
    id: 4,
    text: 'Configuração',
    clickable: true,
    icon: 'Settings',
    componentName: 'modalDivisoes',
  },
];
